// ── Imports ──────────────────────────────
import React, { useState } from 'react';
import { Modal, Button, ListGroup, Form, Container, Row, Col } from 'react-bootstrap';
import ModalAddPermissionToUserRole from './ModalAddPermissionToUserRole';
import ModalForm from '../../Modal/Modal';
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';
import { SmartpayModulesFetchAPI } from '../../../api/SmartPay.Modules';
import { RenderIf } from '../../utils/RenderIf';
import './styles.css';


/* ── ICONS ── */
const IcoModule = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>;
const IcoX = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IcoPlus = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>;
const IcoTrash = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4h6v2" /></svg>;
const IcoDash = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>;
const IcoPos = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>;
const IcoKey = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></svg>;
const IcoCheck = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>;
const IcoNo = () => <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;

/* ════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════ */
function ModalListSmartpayModulesByUserRole({
    smartPayModules, role, token, formData, setShowModal, showModal,
    handleFieldChange, initialFormValues,
    showAsingSmartPayModuleModal, setShowAsingSmartPayModuleModal,
    eventHandler, setEventHandler, business
}) {

 
    /* ════════════════════════════════════
 ************************************************
    ════════════════════════════════════ */
    const asingSmartpayModulesToRole = async (e) => {
        e.preventDefault();
        try {
            formData.role_id = role.id;
            await SmartpayModulesFetchAPI.asingSmartpayModulesToUserRole(formData, token);
            SuccessAlert('Modulo asignado correctamente');
            setEventHandler(1);
        } catch (err) {
            ErrorAlert(err);
        }
    };

    const removeModulePermission = async (permission_id, module_id) => {
        try {
            await SmartpayModulesFetchAPI.removeSmartpayModulePermission(
                { permissionId: permission_id, module_id, role_id: role.id },
                token
            );
            SuccessAlert('Permiso removido correctamente');
            setEventHandler(1);
        } catch (err) {
            ErrorAlert(err);
        }
    };

    const removeModuleFromUserRole = async (module_id) => {
        try {
            await SmartpayModulesFetchAPI.removeSmartpayModuleFromUserRole(
                { module_id, role_id: role.id },
                token
            );
            SuccessAlert('Modulo removido correctamente');
            setEventHandler(1);
        } catch (err) {
            ErrorAlert(err);
        }
    };
    {/* ── ********** ── */ }
    return (
        <>
            {/* ── ********** ── */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
                dialogClassName="msm-dialog"
            >
                <Modal.Header>
                    {/* header custom — sin texto de Bootstrap */}
                    <div className="msm-header" style={{ width: '100%' }}>
                        <div className="msm-header-icon"><IcoModule /></div>
                        <div className="msm-header-info">
                            <div className="msm-header-title">Módulos de Smartpay</div>
                            <div className="msm-header-sub">
                                Gestión de módulos y permisos para el rol seleccionado
                            </div>
                        </div>
                        <button
                            className="msm-header-close"
                            type="button"
                            onClick={() => setShowModal(false)}
                        >
                            <IcoX />
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="msm-body">

                        {/* ── ROL INFO ── */}
                        <div className="msm-role-card">
                            <div className="msm-role-name">{role.name}</div>
                            {role.description && (
                                <div className="msm-role-desc">{role.description}</div>
                            )}
                            <div className="msm-role-badges">
                                <span className={`msm-access-chip ${role.dashboard_login === 1 ? 'msm-chip-yes' : 'msm-chip-no'}`}>
                                    <IcoDash />
                                    Dashboard:&nbsp;
                                    {role.dashboard_login === 1
                                        ? <><IcoCheck /> Sí</>
                                        : <><IcoNo /> No</>
                                    }
                                </span>
                                <span className={`msm-access-chip ${role.pos_login === 1 ? 'msm-chip-yes' : 'msm-chip-no'}`}>
                                    <IcoPos />
                                    POS:&nbsp;
                                    {role.pos_login === 1
                                        ? <><IcoCheck /> Sí</>
                                        : <><IcoNo /> No</>
                                    }
                                </span>
                            </div>
                        </div>

                        {/* ── SECTION: módulos asignados ── */}
                        <div className="msm-section-head d-flex justify-content-between">
                            <span className="msm-section-label">Módulos asignados al rol</span>

                            {/* botón asignar (solo si no es rol default) */}
                            <RenderIf isTrue={role.isdefault === false}>
                                <div style={{ marginBottom: '.85rem' }}>
                                    <button
                                        className="msm-btn-add"
                                        onClick={() => setShowAsingSmartPayModuleModal(true)}
                                    >
                                        <IcoPlus /> Asignar módulo
                                    </button>
                                </div>
                            </RenderIf>
                        </div>



                        {/* ── LISTA DE MÓDULOS ── */}
                        {smartPayModules.length === 0 ? (
                            <div className="msm-modules-empty">
                                <div className="msm-empty-icon"><IcoModule /></div>
                                <p className="msm-empty-text">Este rol no tiene módulos asignados aún.</p>
                            </div>
                        ) : (
                            smartPayModules.map((module, mi) => (
                                <div
                                    className="msm-module-card"
                                    key={module.module_id || mi}
                                    style={{ animationDelay: `${mi * 0.04}s` }}
                                >
                                    {/* module header */}
                                    <div className="msm-module-head">
                                        <div className="msm-module-ico"><IcoModule /></div>
                                        <div className="msm-module-name">{module.module_name}</div>
                                        <div className="msm-module-actions">

                                            {/* agregar permiso (solo si no es rol default) */}
                                            <RenderIf isTrue={role.isdefault === false}>
                                                <ModalAddPermissionToUserRole
                                                    setEventHandler={setEventHandler}
                                                    module={module}
                                                    modulePermissions={module.permissions}
                                                    token={token}
                                                    role={role}
                                                />
                                            </RenderIf>

                                            {/* remover módulo (solo si no es rol default) */}
                                            <RenderIf isTrue={role.isdefault === false}>
                                                <button
                                                    className="msm-btn-remove"
                                                    onClick={() => removeModuleFromUserRole(module.module_id)}
                                                >
                                                    <IcoTrash /> Remover
                                                </button>
                                            </RenderIf>

                                        </div>
                                    </div>

                                    {/* permisos del módulo */}
                                    <RenderIf isTrue={module.moduleUserRolPermissions.length > 0}>
                                        <div className="msm-perms">
                                            {module.moduleUserRolPermissions.map((permission, pi) => (
                                                <div className="msm-perm-row" key={permission.permise_id || pi}>
                                                    <div className="msm-module-ico" style={{ width: 28, height: 28, borderRadius: 7, background: 'rgba(27,58,107,.07)', fontSize: '.75rem' }}>
                                                        <IcoKey />
                                                    </div>
                                                    <div className="msm-perm-body">
                                                        <div className="msm-perm-name">{permission.permission_name}</div>
                                                        <div className="msm-perm-code">
                                                            <span style={{ color: 'var(--text-2)', fontStyle: 'normal' }}>Código:</span> {permission.permission_code}
                                                        </div>
                                                    </div>

                                                    {/* remover permiso (solo si no es rol default) */}
                                                    <RenderIf isTrue={role.isdefault === false}>
                                                        <button
                                                            className="msm-btn-icon"
                                                            title="Remover permiso"
                                                            onClick={() => removeModulePermission(permission.permise_id, module.module_id)}
                                                        >
                                                            <IcoTrash />
                                                        </button>
                                                    </RenderIf>
                                                </div>
                                            ))}
                                        </div>
                                    </RenderIf>

                                    {/* sin permisos */}
                                    <RenderIf isTrue={module.moduleUserRolPermissions.length === 0}>
                                        <div className="msm-perms-empty d-flex  justify-content-center">Sin permisos asignados a este módulo.</div>
                                    </RenderIf>

                                </div>
                            ))
                        )}

                    </div>
                </Modal.Body>
            </Modal>

            {/* ── Modal asignar módulo a rol (importación original intacta) ── */}
            <ModalForm
                modal_body={initialFormValues}
                modal_header_text="Asignar modulo a rol"
                button_text="Crear"
                initialFormValues={formData}
                formType="addForm"
                buttonModal={false}
                setEventHandler={setEventHandler}
                eventHandle={eventHandler}
                submit={asingSmartpayModulesToRole}
                handleFieldChange={handleFieldChange}
                setShowModal={setShowAsingSmartPayModuleModal}
                showModal={showAsingSmartPayModuleModal}
            />
        </>
    );
}

export default ModalListSmartpayModulesByUserRole;